module.exports = __webpack_public_path__ + "static/media/Vijay.ee8d78b2.jpg";